import React, { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { COMPANY } from '../mock';

const TermsPage = ({ data, requiredRef }) => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const allowed = searchParams.get('ref') === requiredRef;

  useEffect(() => {
    if (!allowed) {
      navigate('/', { replace: true });
    }
  }, [allowed, navigate]);

  if (!allowed) return null;

  return (
    <div>
      <section className="ea-hero-gradient py-14">
        <div className="mx-auto max-w-4xl px-5 text-center lg:px-8">
          <h1 className="font-display text-3xl font-extrabold text-white sm:text-4xl">{data.title}</h1>
          <p className="mt-3 text-sm text-white/80">{data.subtitle}</p>
          <p className="mt-1 text-sm text-white/70">{data.effective}</p>
        </div>
      </section>

      <section className="bg-white py-16">
        <div className="mx-auto max-w-4xl px-5 lg:px-8">
          <p className="text-[15px] leading-relaxed text-gray-600">{data.intro}</p>

          <div className="mt-10 space-y-9">
            {data.sections.map((s) => (
              <div key={s.heading}>
                <h2 className="font-display text-lg font-bold text-[#1b4f72]">{s.heading}</h2>
                <div className="mt-3 space-y-3">
                  {s.items.map((it, i) => (
                    <p key={i} className="text-[15px] leading-relaxed text-gray-600">{it}</p>
                  ))}
                </div>
              </div>
            ))}
          </div>

          <div className="mt-12 rounded-2xl bg-[#e9f3ec] p-7 text-sm text-gray-700">
            <p className="font-display font-bold text-[#1b4f72]">E.A. Lead Solutions</p>
            <p>{COMPANY.legal}</p>
            <p className="mt-2">Registered Office: {COMPANY.address}</p>
            <p>Company Number: {COMPANY.companyNumber}</p>
            <p>Email: {COMPANY.email}</p>
            <p>WhatsApp: {COMPANY.whatsappHours}</p>
            <p className="mt-3 text-xs text-gray-500">Copyright © E.A. Lead Solutions</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsPage;
